import { Id } from "PFTypes";

import api from "../../api";

export const deleteActivityEconomicsScenarioAssignment = (id: Id) =>
  api<never>({ url: `scenario_assignments/${id}`, method: "DELETE" });
